// extracted by mini-css-extract-plugin
export default {"value":"playback-rate-option-module__value___AaYzy"};